<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
<!--        <router-link class="ib-back-btn" :to="{ name: 'Policies' }">Back</router-link>-->
        <a class="ib-back-btn" href="#" @click="$router.back()">Back</a>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Risk Detail</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container detail-view-box">
        <div class="row detail-header ib-align-start">
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="detail-header-img">
              <div>
                <img class="img-fluid" :src="policy_detail.product.product_image" v-if="policy_detail.product.plan_name == ''" />
                <img class="img-fluid" :src="policy_detail.product.plan_image" v-if="policy_detail.product.plan_name != ''" />
              </div>
              <div class="header-circle-img">
                <img class="img-fluid" :src="policy_detail.company.logo">
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-6 pl-lg-0 pl-lg-0">
            <h3 class="header-title">{{ policy_detail.product.product_name }}
              <small>{{ policy_detail.insurance_sub_type }}</small>
              <small class="ib-card-plan font-10" v-if="policy_detail.product.plan_name != ''">{{ policy_detail.product.plan_name }}</small>
            </h3>
            <div class="" v-if="policy_detail.policy_no != null">
              <p class="header-td-first">Policy No: <span>{{ policy_detail.policy_no }}</span></p>
            </div>
            <div class="" v-else>
              <p class="header-td-first">Order No: <span>{{ policy_detail.tcn_no }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() != 'expirig_soon' && policy_detail.status.toLowerCase() != 'expired'">
              <p class="header-td-first" v-if="policy_detail.status == 'issued'">Policy Date: <span>{{ formatDate(policy_detail.coverage_initiate_at) }}</span></p>
              <p class="header-td-first" v-else>Order Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() == 'expirig_soon'">
              <p class="header-td-first">Expiring In: <span>{{ calculateExpiry(policy_detail.created_at) }} Days</span></p>
              <p class="header-td-first">Expiring On: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="" v-if="policy_detail.status.toLowerCase() == 'expired'">
              <p class="header-td-first">Expiry Date: <span>{{ formatDate(policy_detail.created_at) }}</span></p>
            </div>
            <div class="">
              <p class="header-td-first">{{ Insured }} Amount: <span>{{ policy_detail.sum_insured_currency }} </span><span style="color: #3d9cbd !important;">{{ priceFormatter(policy_detail.sum_insured) }}</span></p>
            </div>
          </div>
          <div class="col-lg-3">
            <div :class="policy_detail.consumer_status +'-status' " class="text-capitalize mb-3 ib-status" >{{ policy_detail.consumer_status.replace(/_/g,' ') }}</div>
            <div v-if="policy_detail.promo_code != ''">
              <p class="header-td-first">{{NetPremium}}:</p>
              <div class="header-price">{{ policy_detail.currency }}
                <span class="">{{ priceFormatter(policy_detail.price_before_discount) }}</span>
                <div class="in-text-linethrough">
                  {{policy_detail.currency}}&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}
                </div>
                <div class="in-promobox-gear2">
                  <img class="img-fluid in-promo-gear2" :src="require('@/assets/images/applied-promo-gear.svg')" alt="icon">
                  <div>Applied Promo: <span>{{policy_detail.promo_code}}</span></div>
                </div>
              </div>
              <button class="ib-btn-primary in-renew-btn" v-if="(policy_detail.status.toLowerCase() == 'expiring_soon' || policy_detail.status.toLowerCase() == 'expired') && policy_detail.can_renew_policy == 1" @click="renewPolicy(policy_detail)">Renew Now!</button>
            </div>
            <div v-else>
              <p class="header-td-first">{{ NetPremium }}:</p>
              <h3 class="header-price">{{ policy_detail.currency }}<span>&nbsp;{{ priceFormatter(policy_detail.paid_amount) }}</span></h3>
              <button class="ib-btn-primary in-renew-btn" v-if="(policy_detail.status.toLowerCase() == 'expiring_soon' || policy_detail.status.toLowerCase() == 'expired') && policy_detail.can_renew_policy == 1" @click="renewPolicy(policy_detail)">Renew Now!</button>
            </div>
          </div>
        </div>
        <div class="row px-3">
          <h2 class="claim-sub-heading">Quotation Detail</h2>
          <table class="table table-borderless">
            <tr v-for="(data, index) in stage_1" :key="index">
              <td v-for="(item, key) in data" :key="key">
                <p class="claim-row-data claim-row-sub-heading">{{ item.label }}</p>
                <dd class="claim-row-data" v-if="item.label.toLowerCase().includes('dob') || item.label.toLowerCase().includes('date') || item.label.toLowerCase().includes('date')">{{ formatDynamicDate(item.value)}}</dd>
                <dd class="claim-row-data" v-else>{{ item.value}}</dd>
              </td>
            </tr>
          </table>
        </div>
        <div class="row px-3">
          <h2 class="claim-sub-heading" v-if="stage_3.length > 0">Other Detail</h2>
          <table class="table table-borderless">
            <tr v-for="(data, index) in stage_3" :key="index">
              <td v-for="(item, key) in data" :key="key">
                <p class="claim-row-data claim-row-sub-heading">{{ item.label }}</p>
                <dd class="claim-row-data" v-if="item.label.toLowerCase().includes('dob') || item.label.toLowerCase().includes('date') || item.label.toLowerCase().includes('date')">{{ formatDynamicDate(item.value)}}</dd>
                <dd class="claim-row-data" v-else>{{ item.value}}</dd>
              </td>
            </tr>
          </table>
        </div>
        <div class="row px-3" v-if="risk_detail.documents.length > 0"><h2 class="claim-sub-heading">Documents</h2></div>
        <div class="row px-3" v-for="document in risk_detail.documents">
          <div class="col-md-12">
            <div class="row">
              <h4 class="documents-heading" style="text-align:left !important;">{{ document.text.replace(/_/g,' ')}}</h4>
            </div>
            <div class="row in-document-flex">
              <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                <a :href="key.url" target="_blank">
                  <div class="claim-data-icon">
                    <img class="img-fluid" :src="key.url">
                    <p>Document {{ index+1 }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row px-3" v-for="document in policy_detail.documents">
          <div class="col-md-12">
            <div class="row">
              <h4 class="documents-heading" style="text-align:left !important;">{{ document.text.replace(/_/g,' ')}}</h4>
            </div>
            <div class="row in-document-flex">
              <div class="claim-doc-icon" v-for="(key, index) in document.urls">
                <a :href="key.url" target="_blank">
                  <div class="claim-data-icon">
                    <img class="img-fluid" :src="key.url">
                    <p>Document {{ index+1 }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="row px-3" v-if="risk_detail.inspection_images.length > 0"><h2 class="claim-sub-heading">Self Inspection Images</h2></div>
        <div class="row px-3" v-for="section in risk_detail.inspection_images" v-if="risk_detail.inspection_images.length > 0">
          <div class="col-md-12">
            <div class="row">
              <h4 class="documents-heading">{{ section.text.replace(/_/g,' ')}}</h4>
            </div>
            <div class="row mb-3 mx-auto mx-md-0">
              <div class="col-md-2 claim-car-icon" v-for="(key, index) in section.urls">
                <a :href="key.url" target="_blank">
                  <!-- class="claim-car-icon" -->
                  <div>
                    <img class="img-fluid" :src="key.url">
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/Loading'
import moment from "moment";
import _ from 'lodash';

export default {
  name: 'ViewRisk',
  components: {
    loading
  },
  data() {
    return {
      beneficiaries_area: false,
      family_area: false,
      showLoader: true,
      policy_detail: {},
      risk_detail: {},
      beneficiaries: {},
      family: {},
      insurer_detail: {},
      selectedProduct: {},
      modal_detail: '',
      modal_heading: '',
      sections: {},
      plan_detail: {},
      showProducts: false,
      source: this.$route.params.source,
      customer: 'customer',
      Insured : 'Insured',
      SuInsured : 'Sum Insured',
      NetPremium : 'Net Premium',
      GrossPremium : 'Gross Premium',
      Coverage : 'Coverages',
      FIF: 'FIF',
      CoverLimit : 'Cover Limit',
      stage_1 : [],
      stage_3 : [],
      policyRisks : {},
      filterPolicyRisks : {},
      searchKey: '',
      riskId : this.$route.params.id,

    };
  },
  created: function () {
    const self = this;
    self.getPolicy(self.$route.params.policyId);
  },
  computed: {
    chunked() {
      return _.chunk(this.risk_detail.form_data.stage_1,4);
    },
    date() {
      return moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    riskDetail: async function (id){
      const self = this;
      self.showLoader = true;
      await axios.get('customer/risk_detail?form_data=1&quotation_risk_id=' + id).then(function (resp) {
        if (resp.data.code == 200) {
          self.risk_detail = resp.data.data;
          self.FilterDate(self.risk_detail.form_data.stage_1);
          self.FilterDate(self.risk_detail.form_data.stage_3);

          self.stage_1 = self.chunkedData(self.risk_detail.form_data.stage_1);
          self.stage_3 = self.chunkedData(self.risk_detail.form_data.stage_3);
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async getPolicy(id) {
      var self = this;
      self.showLoader = true;
      await axios.get('customer/policy_detail?id=' + id).then(function (resp) {
        if (resp.data.code == 200) {
          self.policy_detail = resp.data.data;

          if (self.policy_detail.is_takaful == 1){
            self.replaceString();
          }
          self.BeneficiaryDetail(resp.data.data.id, self.policy_detail.consumer_status);
          self.FamilyDetail(resp.data.data.id);
          self.insurerDetail(resp.data.data.id);
          self.planDetail(self.policy_detail.plan_id);

          axios.get('customer/risk_detail?customer_quotation_id=' + id + '&quotation_risk_id=' +self.riskId).then(function (response) {
            if (response.data.code == 200) {
              self.risk_detail = response.data.data;
              self.stage_1 = self.chunkedData(self.risk_detail.form_data.stage_1);
              self.stage_3 = self.chunkedData(self.risk_detail.form_data.stage_3);
              self.FilterDate(self.risk_detail.form_data.stage_1);
              self.FilterDate(self.risk_detail.form_data.stage_3);

              self.showLoader = false;
            }
          })

        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }



      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },

    ViewDetail(key) {
      var self = this;
      if (key == 'product') {
        document.getElementById("DetailModal").setAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'block';
        document.getElementById("DetailModal").classList.add("show");
        self.modal_heading = 'Product';
        self.modal_detail = self.plan_detail.product.description;
      } else if(key == 'things_to_note') {
        document.getElementById("DetailModal").setAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'block';
        document.getElementById("DetailModal").classList.add("show");
        self.modal_heading = 'Things To Note';
        self.modal_detail = self.plan_detail.things_to_note;
      } else if(key == 'why_buy') {
        document.getElementById("DetailModal").setAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'block';
        document.getElementById("DetailModal").classList.add("show");
        self.modal_heading = 'Why Buy';
        self.modal_detail = self.plan_detail.why_buy;
      } else if(key == 'core_covers') {
      } else if(key == 'exclusions') {
        document.getElementById("DetailModal").setAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'block';
        document.getElementById("DetailModal").classList.add("show");
        self.modal_heading = 'Exclusions';
        self.modal_detail = self.plan_detail.exclusions;
      } else if(key == 'brochure') {
        window.open(self.plan_detail.brochure,'_blank');
      } else if(key == 'claim_example') {
        document.getElementById("DetailModal").setAttribute("role", "dialog");
        document.getElementById("DetailModal").style.display = 'block';
        document.getElementById("DetailModal").classList.add("show");
        self.modal_heading = 'Claim Example';
        self.modal_detail = self.plan_detail.claim_example;
      } else if(key == 'glossary_file') {
        window.open(self.plan_detail.glossary_file,'_blank');
      }
    },
    chunkedData(data) {
      return _.chunk(data,4);
    },
    formatDate(date) {
      return moment(date).format('DD-MMM-YYYY');
    },
    formatDynamicDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    riskListing: async function (id) {
      const self = this;
      self.showLoader = true;
      await axios.get('customer/risks_listing?form_data=1&customer_quotation_id=' + id).then(function (resp) {
        if (resp.data.code == 200) {
          self.policyRisks = resp.data.risks;
          self.filterPolicyRisks = resp.data.risks;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }



      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async planDetail(id) {
      var self = this;
      self.showLoader = true;
      await axios.get('plan_detail/' + id + '?customer_quotation_id=' + self.$route.params.id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.plan_detail = resp.data.data.plan;
          self.selectedProduct = self.plan_detail;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async BeneficiaryDetail (id, status) {
      var self = this;
      self.$route.params.id
      url = 'customer/policy_beneficiaries?policy_id=' + id;
      if (status === 'inprocess') {
        var url = 'customer/policy_beneficiaries?status=inactive&policy_id=' + id;
      }
      self.showLoader = true;
      await axios.get(url).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.beneficiaries = resp.data.data;
          if (self.beneficiaries.length > 0){
            self.beneficiaries_area = true;
          }
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async FamilyDetail (id) {
      var self = this;
      let url = 'customer/policy_family_members?policy_id=' + id;
      self.showLoader = true;
      await axios.get(url).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.family = resp.data.data;
          if (self.family.length > 0){
            self.family_area = true;
          }
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    async insurerDetail(id) {
      var self = this;
      self.$route.params.id;
      self.showLoader = true;
      await axios.get('customer/quotation/customer_details?quotation_id=' + id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {
          self.insurer_detail = resp.data.data;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    FilterDate(data) {
      var self = this;
      let list = {};
      $.each(data, function(key, value) {
        if (list[value.section_name] === undefined ) {
          list[value.section_name] = [];
        }
        list[value.section_name].push(value);
      });
      list = Object.assign({}, list);
      self.sections = list;
    },
    renewPolicy(policy) {
      const self = this;
      if(policy.can_renew_policy) {
        self.$router.push({ name: 'Renew', params: { quotationId: policy.id, subClassId: policy.subclass_id } });
      } else {
        $toast.error('Cannot renew this policy', { position: 'top-right' });
      }
    },
    calculateExpiry(date) {
      var eventdate = moment(date, "YYYY-MM-DD");
      var todaysdate = moment();
      return eventdate.diff(todaysdate, 'days') < 0 ? 0 : eventdate.diff(todaysdate, 'days');
    }
  }
};
</script>

<style scoped>
.active {
  display: block !important;
}
.tab-pane {
  display: none;
}
.claim-doc-icon p {
  font-family: "Avenir Medium";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c505d;
  margin-bottom: 0px;
}
.claim-data-icon img {
  margin: 0 auto;
}
/* .claim-data-icon {
  width: 121px;
  height: 124px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
} */
.claim-data-icon img{
  width: 40px;
  margin-top: 8px;
}
/* .claim-data-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
} */
.claim-row-sub-heading {
  font-family: "Avenir Book";
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  padding-left: 20px;
  color: #ef7c94;
  color: #ef7c94 !important;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
  border: solid 1px transparent;
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  background-color: #def3f7;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
  border: solid 1px var(--primary-color);
  background-color: var(--primary-color);
  color: #fff !important;
  height: 61px;
  border-radius: 31px;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.jbl-nav-tabs .nav-item .nav-link {
  color: #5b6770;
}
.jbl-nav-tabs {
  border-radius: 31px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  background-color: #def3f7;
  border: 0;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
  margin: 20px 0 10px 15px;
  /* padding-top: 1px;
  padding-bottom: 1px; */
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.claim-sub-heading {
  width: 100%;
  min-height: 54px;
  margin: 20px 0px;
  padding: 16px;
  border-radius: 7px;
  /* border: dotted 2px #3d9cbd; */
  border: dashed 2px #3d9cbd;
  background-color: rgba(61, 156, 189, 0.03);
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-sub-heading {
  font-family: "Avenir Heavy";
  font-size: 16px;
  /* font-weight: 900; */
  text-align: left;
  color: #ef7c94 !important;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Avenir Medium";
}
.data-row .claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.37;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.data-row .claim-row-heading {
  font-family: "Avenir Medium";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
label {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 1px;
  left: .5em;
  z-index: 1;
  height: 1em;
  font-size: 13px;
  line-height: 3.5em;
  color: #999;
  white-space: nowrap;
  cursor: text;
  transition:all .1s ease;
}
.input-placeholder:focus ~ label, .input-placeholder:valid ~label {
  font-size:11px;
  left:10px;
  top:-10px;
}
.input-placeholder:valid ~label {
  color:green;
}
.input-placeholder:focus:invalid ~label {
  color:red;
}
.jbl-data-img{
  width: 100px;
  height: 65px;
  margin-right: .6rem;
}
.table.table-borderless td {
  padding: 1rem 0rem;
}
@media (max-width:576px) {
  nav.nav-tabs.jbl-nav-tabs{
    margin: 0 auto;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    height: 2.2rem;
  }

  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px #007bff;
    height: 2.2rem;
  }
  .jbl-nav-tabs {
    font-size: 14px;
  }
  .nav-item .nav-link{
    padding: 0.5rem .5rem;
  }
}
dd.claim-row-data {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}
.col-md-3 p.claim-row-data:nth-of-type(2) {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
  padding-left: 20px;
}

.claim-data-icon img {
  margin: 0 auto;
}
.claim-car-icon {
  width: 165.3px;
  height: 122.9px;
  border-radius: 10px;
  border: solid 1px #e5e5e5;
  background-color: #ffffff;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  display: flex !important;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  margin: 1rem !important;
  padding-left: 10px !important;
  padding-left: 10px !important;
  overflow: hidden;
}
.claim-car-icon img{
  width: 100%;
  height: auto;
  margin-top: 8px;
}
.claim-car-icon:not(:nth-of-type(1)) {
  margin-left: 15px;
  margin-right: 15px;
}
button:hover, button:focus{
  border: 1px solid transparent !important;
  outline: transparent !important;
  box-shadow: transparent !important;
  text-decoration: none !important;
}
.claim-data-icon img {
  margin: 0 auto;
}
.data-row p {
  color :#5b6770;
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.data-row .claim-row-sub-heading {
  color: #a9adaf;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  margin: 10px 61.3px 10px 52px;
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Futura PT";
}
.data-row .claim-row-data {
  font-family: "Futura PT";
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 8px;
  letter-spacing: normal;
  text-align: left;
}
.data-row .claim-row-heading {
  font-family: "Futura PT";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.in-listing-img {
  width: 79px;
  height: 66px;
  background-color: #ecf3f5;
  border-radius: 11px;
  border: 1px solid gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.in-listing-img img{
  width: 100% !important;
  max-width: 70px !important;
  max-height: 60px !important;
  height: auto !important;
}

.position-relative-box {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: absolute;
  bottom: -10px;
  right: -10px;
}
.position-relative-box img{
  width: 100% !important;
  max-width: 23px !important;
  height: auto !important;
}
table.claim-listing {
  width: 100%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-collapse: separate;
  border-spacing: 0 10px;
}
table.claim-listing td {
  height: 100px !important;
  vertical-align: middle;
  text-align: center;
  position: relative;
}
@media (max-width:668px) {
  table.claim-listing td:not(:first-child) {
    height: 60px !important;
  }
  table.claim-listing tbody td:first-child{
    height: auto !important;
  }
}
table.claim-listing td:last-child:after {
  content: none;
}
table.claim-listing tbody td {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
@media (min-width:669px) {
  table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  table.claim-listing tbody td:last-child {
    border-right: 1px solid #eee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  table.claim-listing tbody tr {
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
}
.jbl-table-heading {
  font-family: "Avenir Medium";
  font-weight: 500;
  text-align: left !important;
  font-size: 19px;
  color: #5b6770;
}

.jbl-table-heading span {
  font-weight: normal !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-table-heading small {
  font-weight: normal !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-date-td {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
}
.jbl-date-heading {
  color: #ef7c94 !important;
  font-family: "Avenir Book";
  font-size: 13px;
  text-align: left;
}
table.claim-listing .fa-chevron-right {
  padding-right: 2rem;
  color: #5b6770;
}
.jbl-flex-td {
  display: flex;
  flex-direction: column;
}
@media (min-width:668px) and (max-width:992px) {
  .jbl-table-heading {
    font-size: 14px;
  }
  .jbl-date-td {
    font-family:"Futura PT Medium";
    font-size: 12px;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 1rem;
    color: #5b6770;
  }
}
.d2c-main-classes {
  background-color: #def3f7;
  border-radius: 31px;
  max-width: fit-content;
  margin: 1px 0 30px;
}
.d2c-class-btn {
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 61px;
  margin: 0 0 1px;
  border-radius: 31px;
  background-color: #def3f7;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.38;
  color: #4c505d;
  transition: all .3s ease-in;
}
@media(max-width:550px){
  .d2c-class-btn{
    padding: 6px 22px !important;
    width: max-content !important;
    font-size: 12px !important;
  }
}
.d2c-class-btn:hover {
  background-color: #049cbd;
  color: white;
}
.d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
  outline: none !important;
  background-color: #049cbd;
  color: white;
}
.nex-Page-Link .fa-chevron-right {
  color: #aeccd6 !important;
  font-weight: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Policy/RiskDetail.vue